import React from "react";
import PropTypes from "prop-types";
import { getCollectionTemplate } from "../get-collection-template";
import get from "lodash/get";
import { LazyCollection } from "@quintype/components";
import { overrideLayouts } from "../../utils";

export class HomePage extends React.Component {
  render() {
    const collection = overrideLayouts(this.props.config, this.props.data.collection, "home");
    return (
      <div className="home-page">
        {/* Don't want to show it user but need it for SEO reasons🙄 */}
        <h1 style={{ display: "none" }}>
          {get(this.props.config, ["publisher-settings", "title"], this.props["publisher-name"])}
        </h1>
        <LazyCollection collection={collection} collectionTemplates={getCollectionTemplate} lazyAfter={3} />
      </div>
    );
  }
}
HomePage.propTypes = {
  config: PropTypes.shape({
    "publisher-settings": PropTypes.object,
    title: PropTypes.string
  }),
  data: PropTypes.shape({
    collection: PropTypes.object
  }),
  "publisher-name": PropTypes.string
};
